import React, { useCallback, MouseEvent } from 'react';
import { Box, useTheme } from '@mui/material';

interface Props {
  tocHtml: string;
  onClick?: (value: string) => void;
}
const TocCard = ({ tocHtml, onClick }: Props) => {
  const { spacing, typography, shape, palette } = useTheme();

  const handleClickList = useCallback(
    (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      try {
        if (target.tagName !== 'A') {
          return;
        }
        const value = decodeURIComponent((target as HTMLAnchorElement).innerText);
        onClick?.(value);
      } catch (e) {
        console.error(e);
      }
    },
    [onClick]
  );

  return (
    <Box
      onClick={handleClickList}
      dangerouslySetInnerHTML={{ __html: tocHtml }}
      sx={{
        '& ul': {
          padding: 0,
          margin: 0,
        },
        '& li': {
          padding: 0,
          margin: 0,
          listStyle: 'none',
          '& p': {
            margin: 0,
          },
          '& a': {
            display: 'block',
            padding: `${spacing(1)} ${spacing(1.5)} ${spacing(1)} ${spacing(0.75)}`,
            marginLeft: spacing(0.75),
            color: palette.grey['800'],
            textDecoration: 'none',
            fontSize: typography.caption.fontSize,
            borderRadius: shape.borderRadius,
            '&:hover': {
              backgroundColor: palette.grey['100'],
            },
          },
        },
        '& li ul': {
          margin: `0 0 ${spacing(1.5)} ${spacing(1.5)}`,
          borderLeft: `1px dashed ${palette.grey['400']}`,
        },
      }}
    />
  );
};

export default TocCard;
